import React, { useRef, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import RichTextEditor from 'srcReact/components/common2/RichTextEditor'
import Icon from 'srcReact/components/icons/Icon'
import styles from './styles.module.scss'
import Link from 'react-router-dom/Link'
import Avatar from 'srcReact/components/common2/Avatar'
import useDetectKeyboardOpen from 'srcReact/helpers/hooks/useDetectKeyboardOpen '
import AnimatedButton from '../../../AnimatedButton'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import ReadMore from 'srcReact/components/common2/ReadMore'
import { getParsedMessage, trimDivsFromMessage } from 'srcReact/helpers/feedHelper'

function CreateFeedMobile({
  isEditMode,
  loadingSendMessage,
  content,
  posted,
  messageType,
  commentToUser,
  entity,
  post,
  emoji,
  existingContent, // applicable in case of  draft or edit mode
  filesToUpload,
  handleFiles,
  getFileError,
  error,
  activeUsers,
  isGeneral = false,
  handleShowNewsFeedPopup,
  userToTag,
  fileCount,
  newsFeedId,
  originMessageId,
  draftMessages,
  sharedImageDataUrls,
  sharedImagesToUpload,
  setSharedImageDataUrls,
  setSharedImagesToUpload,
  sharedText,
  handleSendMessage,
  handleFocus,
  handleBlur,
  handleChange,
  focusedMode,
  handleErrorFromInputArea
}) {
  const { t } = useTranslation()
  const rteRef = useRef(null)
  const {
    login: { user: loggedInUser }
  } = useSelector((state) => state)

  const isKeyboardOpen = useDetectKeyboardOpen()
  const [originalMessageText, setOriginalMessageText] = useState(post?.message ?? '')

  useEffect(() => {
    //trim empty divs from start and end of the message
    if (post?.message) {
      const parsedMessage = getParsedMessage(post.message)
      const trimmedMessage = trimDivsFromMessage(
        post.message,
        parsedMessage,
        post.newsfeed_template,
        post.is_automatic_message
      )
      setOriginalMessageText(trimmedMessage)
    }
  }, [post])

  //1206390645427630 - extracted this to a function
  const getUserToTag = () => {
    const isDraftAvailableInGeneralFeed =
      draftMessages &&
      draftMessages[newsFeedId] &&
      draftMessages[newsFeedId][originMessageId] &&
      draftMessages[newsFeedId][originMessageId].message.length > 0
    const isDraftAvailableInCommentFeed =
      draftMessages && draftMessages[originMessageId] && draftMessages[originMessageId].message.length > 0
    if (isDraftAvailableInGeneralFeed || isDraftAvailableInCommentFeed) {
      return null
    } else if (messageType === 'reply') {
      //if message type is reply the show user tag upon showing reply text area/modal
      //userToTag will be null if message is triggered or posted
      return userToTag
    }
    return null
  }

  return (
    <React.Fragment>
      <div className={styles.container}>
        {isGeneral && !isEditMode && messageType !== 'comment' && messageType !== 'reply' && (
          <div className={styles.selectedNewsFeed} role='button' onClick={handleShowNewsFeedPopup}>
            {entity.picture ? (
              <img
                src={entity.picture?.url ? entity.picture.url : entity.picture}
                alt={entity.name}
                className={styles.picture}
              />
            ) : (
              <img
                src={require('../../../../../assets/images/background-default-mixr.jpg')}
                alt='default'
                className={styles.picture}
              />
            )}
            <h2 className={styles.title}>{entity.name}</h2>
            <Icon name='chevron-down' className={styles.chevronDownIcon} />
          </div>
        )}

        <h1 className={styles.title}>
          {messageType === 'comment'
            ? t('mixrHome.feeds.commentTitle')
            : messageType === 'reply'
            ? t('mixrHome.feeds.replyTitle')
            : isEditMode
            ? t('createPost.titleEdit')
            : t('createPost.title')}
        </h1>

        {(messageType === 'comment' || messageType === 'reply') && (
          <React.Fragment>
            <div className={styles.entity}>
              <h2 className={styles.entityName}>
                {messageType === 'comment' ? t('createPost.commentTitle1') : t('createPost.replyTitle1')}&nbsp;
                <Link to={`/0/profile/${commentToUser.id}`}>
                  {`${commentToUser.firstname} ${commentToUser.lastname}`}
                </Link>
                's {t('createPost.commentTitle2')} <span className={styles.greenMixrText}>{entity.name}</span>
              </h2>
            </div>
            <div className={styles.postContainer}>
              <Avatar
                userId={commentToUser.id}
                profilePicture={commentToUser.profile_picture_url}
                showUserName={false}
                imgWrapperSize='tiny'
                mimeType={commentToUser.mimeType}
                originalTag={commentToUser.originalTag}
                isOriginal={commentToUser.isOriginal}
                withExpertiseGroup={commentToUser.with_expertise_group}
              />
              <ReadMore
                enableTrim={true}
                maxLines={2}
                className={styles.originalPostMessage}
                showMoreText={t('global.seeMore')}
                showLessText={t('global.seeLess')}>
                {originalMessageText}
              </ReadMore>
            </div>
          </React.Fragment>
        )}
        {/* <div className={styles.entity}>
            {entity?.picture && <img className={styles.entityPicture} src={entity.picture.url || entity.picture} />}
            {entity && entity.name && <h2 className={styles.entityName}>{entity.name}</h2>}
          </div> */}
        <div
          ref={rteRef}
          data-typeid={entity && entity.id}
          data-type={entity && entity.type}
          data-groupid={entity && entity.groupId}
          className={`${appConstantSettings.DIV_TAG_CONTAINER}_CREATE_POST ${styles.editorContainer} ${
            focusedMode ? (content?.hasError ? styles.editorContainerErrorFocused : styles.editorContainerFocused) : ''
          } ${isKeyboardOpen && styles.editorContainerWithOpenKeyBrd} ${
            messageType !== 'comment' && messageType !== 'reply' && styles.editorContainerWithTextFormat
          }`}
          onFocus={handleFocus}
          onBlur={handleBlur}>
          <RichTextEditor
            isEditMode={isEditMode}
            showTextFormatter={messageType !== 'comment' && messageType !== 'reply'}
            showEmojiPicker={true}
            showFilePicker={!isEditMode}
            showDocumentPicker={!isEditMode}
            placeholder={
              messageType === 'comment'
                ? t('mixrHome.feeds.commentPlaceholder')
                : messageType === 'reply'
                ? t('mixrHome.feeds.replyPlaceholder')
                : `${t('global.writePost')}...`
            }
            handleChange={handleChange}
            containerCSS={styles.richTextAreaWrapper}
            charLimit={appConstantSettings.MAX_CHAR_COUNT}
            maxLines={appConstantSettings.MAX_LINES}
            handleInputError={handleErrorFromInputArea}
            getFileError={getFileError}
            existingEmoji={emoji}
            editorId={`createPost`}
            errorMessageRequired={t('error.required', { field: t(`formlabel.${content?.name}`) })}
            errorMessageLimitExceed={t('global.messageLimit', {
              limit: appConstantSettings.MAX_CHAR_COUNT
            })}
            keepFormatOnPopulate={true}
            showAdvFormat={true}
            existingFiles={filesToUpload}
            handleFiles={handleFiles}
            activeUsers={activeUsers}
            mentionMenuOrientation='bottom'
            userToTag={getUserToTag()}
            value={existingContent}
            sharedImageDataUrls={sharedImageDataUrls}
            sharedImagesToUpload={sharedImagesToUpload}
            setSharedImageDataUrls={setSharedImageDataUrls}
            setSharedImagesToUpload={setSharedImagesToUpload}
            focusInput={true} //directly focus RTE(with cursor), once popup is open
          />
        </div>
        {content?.hasError && <ErrorMessage text={content.errorMessage} className={styles.error} />}
        {error?.length > 0 && <ErrorMessage text={error} className={styles.error} />}
        <div className={styles.buttonWrapper}>
          <AnimatedButton
            // loading={loadingSendMessage && fileCount === 0} //show loading only for plain text message feed
            // isDone={posted || (loadingSendMessage && fileCount > 0)}
            loading={loadingSendMessage} //show loading only for plain text message feed
            isDone={posted}
            afterText={isEditMode ? t('createPost.btnUpdated') : t('createPost.btnPosted')}
            beforeText={isEditMode ? t('global.update') : t('global.post')}
            onClick={handleSendMessage}
          />
        </div>
      </div>
    </React.Fragment>
  )
}

export default CreateFeedMobile
